import { axios,empoyAxios,axiosempo } from '../utils'

export default Vue => {
  // mount the axios to Vue
  Object.defineProperties(Vue, {
    axios: { get: () => axios },
    empoyAxios: {get: ()=>empoyAxios},
		axiosempo: {get: ()=>axiosempo},
    
  })

  // mount the axios to Vue component instance
  Object.defineProperties(Vue.prototype, {
    $axios: { get: () => axios },
    $employAxios: {get: ()=> empoyAxios},
		$axiosempo: {get: ()=> axiosempo},
    
  })
}
